import { render } from "./ConnectionStatus.vue?vue&type=template&id=bf8aa3b8&scoped=true"
import script from "./ConnectionStatus.vue?vue&type=script&lang=js"
export * from "./ConnectionStatus.vue?vue&type=script&lang=js"

import "./ConnectionStatus.vue?vue&type=style&index=0&id=bf8aa3b8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8aa3b8"]])

export default __exports__